// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"506":"0e31be4440b3c894","741":"1461f8579c99c4ea"}[chunkId] + ".js";
};